'use client';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { type ReactNode, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import navigatorQrCode from './NavigatorModal/navigator-promo-qr.svg';

const AppQrCodeModal = dynamic(() => import('@alltrails/layout/components/AppQrCodeModal'), { ssr: false });
const CollectionsModal = dynamic(() => import('./CollectionsModal'), { ssr: false });

const MarketingModals = () => {
  const searchParams = useSearchParams();
  const [children, setChildren] = useState<ReactNode>(null);

  useEffect(() => {
    if (searchParams.has('collections_desktop')) {
      setChildren(<CollectionsModal isOpen onRequestClose={() => setChildren(null)} />);
    } else if (searchParams.has('navigator_desktop')) {
      setChildren(
        <AppQrCodeModal
          isOpen
          onRequestClose={() => setChildren(null)}
          qrCode={navigatorQrCode}
          subtitleMobile={<FormattedMessage defaultMessage="Navigator is only for iOS or Android." />}
          title={<FormattedMessage defaultMessage="Download the AllTrails app to use Navigator" />}
        />
      );
    } else {
      setChildren(null);
    }
  }, [searchParams]);

  return children;
};

export default MarketingModals;
